import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnMultiSelect,
  columnName,
  columnTools,
  columnUsers,
  hasColumn,
} from '@/constants/fields';
import { userGroupUrl } from '@/constants/urls';
import MessageCell from '@/components/table/MessageCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import SystemFlag from '@/components/SystemFlag';
import UserGroupTools from '../containers/UserGroupTools';

const UserGroupRow = ({
  className,
  columns = [columnMultiSelect, columnName, columnUsers],
  onCheckBoxClick,
  upward,
  userGroup,
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-user-group-row', className)}
    code={userGroup.code}
    columns={columns}
    description={userGroup.description}
    entity="usergroup"
    href={userGroupUrl(userGroup)}
    name={userGroup.name}
    onSelect={() => onCheckBoxClick(userGroup.code)}
    selected={userGroup.selected}
    renderSystemFlag={() => <SystemFlag messageId="usergroup.bpmn" />}
    system={userGroup.bpmn}
  >
    {hasColumn(columns, columnUsers) && (
      <MessageCell
        messageId="users.count"
        messageArgs={{ total: userGroup.metrics.all_users, approved: userGroup.metrics.approved_users }}
      />
    )}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <UserGroupTools upward={upward} url={userGroupUrl(userGroup, '#')} userGroup={userGroup} />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default UserGroupRow;
